import { useTranslation } from 'react-i18next';
import { Button, Checkbox, Col, Collapse, Drawer, Form, message, Modal, Radio, Row, Space, TableColumnsType, TableProps, Typography } from 'antd'
import React, { useEffect, useState } from 'react'
import TableData from '../../../table-data/TableData'
import "./index.scss"
import { isEmpty, size } from 'lodash'
import { getTableDataDetailSequence } from '../../../../service/content-list-course/contentListCourseApi'
import { formatDate } from '../../../../utils/converDate'
import FormItemDropdown from '../../../form-dropdown/FormItemDropdown'
import TextArea from 'antd/es/input/TextArea'
import { DEFAULT_MAX_LENGTH_COURSE_TEXTAREA } from '../../../../constants'
import { ExclamationCircleOutlined } from '@ant-design/icons'
import { getAllEnterpriseCustomer } from '../../../../service/list-account-users/listAccountUsersApi'
import { approveRequestJoinMooc, getAccountByUniversity, getAllEnterpriseUniversity, getAllEnterpriseUniversityVer2 } from '../../../../service/management-participate-platform'
import FormItem from 'antd/es/form/FormItem'

type Props = {
  open: boolean
  onClose: () => void
  getListData: () => void
  detailData: any
}

export default function ConfirmRequestParticipateDrawer(props: Props) {
  const { t } = useTranslation();
  const { open, onClose, detailData, getListData } = props
  const validations = {
    enterpriseCheckbox: {
      required: true,
      validator: (_: unknown, value: boolean) => {
        if (!value) {
          return Promise.reject(new Error(t("Không được bỏ trống", "Không được bỏ trống")));
        }
        return Promise.resolve();
      }
    },
    enterprise: {
      required: true,
      validator: (_: unknown, value: string) => {
        if (!value) {
          return Promise.reject(new Error(t("Vui lòng chọn Trường đại học", "Vui lòng chọn Trường đại học")));
        }
        return Promise.resolve();
      }
    },
    accountCheckbox: {
      required: true,
      validator: (_: unknown, value: boolean) => {
        if (!value) {
          return Promise.reject(new Error(t("Không được bỏ trống", "Không được bỏ trống")));
        }
        return Promise.resolve();
      }
    },
    account: {
      required: true,
      validator: (_: unknown, value: string) => {
        if (!value) {
          return Promise.reject(new Error(t("Vui lòng chọn tài khoản", "Vui lòng chọn tài khoản")));
        }
        return Promise.resolve();
      }
    },
    createCourseCheckbox: {
      required: true,
      validator: (_: unknown, value: boolean) => {
        if (!value) {
          return Promise.reject(new Error(t("Không được bỏ trống", "Không được bỏ trống")));
        }
        return Promise.resolve();
      }
    },
  };
  const [form] = Form.useForm()
  const { Panel } = Collapse;

  const [listTableDataDetail, setListTableDataDetail] = useState<any>([])
  const [listAccount, setListAccount] = useState<any>([])
  const [status, setStatus] = useState<any>([])
  const [pageNumber, setPageNumber] = useState<number>(1)
  const [pageSize, setPageSize] = useState<number>(10)
  const [totalRecords, setTotalRecords] = useState<number>(0)
  const [loading, setLoading] = useState<boolean>(false)
  const [statusOrder, setStatusOrder] = useState<string>("")
  const [fieldSortOrder, setFieldSortOrder] = useState<string>("")
  const [listEnterPrise, setListEnterPrise] = useState<any>([])
  const [listCheckbox, setListCheckbox] = useState<any>({
    createSchoolInfo: false,
    createAccountInfo: false,
    createCourseInfo: false
  })

  const getListDataDetail = async () => {
    const data = {
      page: pageNumber,
      size: pageSize,
      sort: statusOrder,
      sequenceId: detailData?.id
    }
    await getTableDataDetailSequence(data).then((res) => {
      setListTableDataDetail(res.data?.data?.content)
    })
  }

  const onSave = async (values: any) => {
    const data = {
      id: detailData?.id,
      universityId: listCheckbox.createSchoolInfo ? values.enterpriseId : null,
      userIds: listCheckbox.createAccountInfo && values.accountId ? [values.accountId] : null,
      isCreatedPage: listCheckbox.createCourseInfo,
      description: listCheckbox.createCourseInfo ? values.createAccount : ""
    }
    await approveRequestJoinMooc(data).then((res) => {
      if (res.status === 200) {
        onClose()
        message.success(t("Lưu thông tin thành công", "Lưu thông tin thành công"))
        getListData()
      }
    })
  }

  const getAllEnterprise = async () => {
    const data = {
      page: 1,
      size: 10000
    }
    // await getAllEnterpriseUniversity(data).then((res) => {
    //   if (res.status === 200) {
    //     const arr = res.data?.data?.content?.map((item: any) => ({
    //       id: item.universityId,
    //       name: item.name
    //     }))
    //     setListEnterPrise(arr)
    //   }
    // })
    await getAllEnterpriseUniversityVer2({}).then((res) => {
      if (res.status === 200) {
        const arr = res.data?.data?.map((item: any) => ({
          id: item.universityId,
          name: item.name
        }))
        setListEnterPrise(arr)
      }
    })
  }

  const getListAccount = async () => {
    await getAccountByUniversity(detailData?.universityId).then((res) => {
      if (res.status === 200) {
        setListAccount(res.data?.data)
      }
    })
  }

  // Checkbox
  const checkEnterpriseCheckbox = Form.useWatch('enterpriseCheckbox', form);
  const checkAccountCheckbox = Form.useWatch('accountCheckbox', form);
  const checkCreateCourseCheckbox = Form.useWatch('createCourseCheckbox', form);

  // useEffect
  useEffect(() => {
    if (open) {
      getListDataDetail();
      getAllEnterprise()
      getListAccount()
    } else {
      form.resetFields();
      setListCheckbox({
        createSchoolInfo: false,
        createAccountInfo: false,
        createCourseInfo: false,
      })
    }
  }, [open]);

  useEffect(() => {
    setListCheckbox({
      ...listCheckbox,
      createSchoolInfo: checkEnterpriseCheckbox,
    });

    if(!checkEnterpriseCheckbox) {
      form.setFieldValue("enterpriseId",null);
    }
  }, [checkEnterpriseCheckbox]);

  useEffect(() => {
    setListCheckbox({
      ...listCheckbox,
      createAccountInfo: checkAccountCheckbox,
    });

    if(!checkAccountCheckbox) {
      form.setFieldValue("accountId",null);
    }
  }, [checkAccountCheckbox]);

  useEffect(() => {
    setListCheckbox({
      ...listCheckbox,
      createCourseInfo: checkCreateCourseCheckbox,
    });
  }, [checkCreateCourseCheckbox]);

  return (
    <Form.Provider onFormFinish={(name, { values, forms }) => {
      if (name === "confirm-participate-account") {
        Modal.confirm({
          title: `Xác nhận xử lý đăng ký`,
          content: `Đảm bảo tất cả các thông tin liên quan đã được kiểm tra trước khi gửi`,
          onOk: () => {
            onSave(values)
          },
          okText: t("Xác nhận", "Xác nhận"),
          cancelText: t("Huỷ bỏ", "Huỷ bỏ"),
          centered: true,
          icon: <ExclamationCircleOutlined style={{ color: "#1677FF" }} />,
          footer: (_, { OkBtn, CancelBtn }) => (
            <>
              <CancelBtn />
              <OkBtn />
            </>
          ),
        });
      }
    }}>

      <Drawer
        title={t("Xử lý yêu cầu tham gia nền tảng", "Xử lý yêu cầu tham gia nền tảng")}
        open={open}
        onClose={onClose}
        className='management-participate-detail-drawer'
        width={"60%"}
        bodyStyle={{ padding: "0px" }}
        extra={
          <Space>
            <Button onClick={onClose}>{t("Đóng", "Đóng")}</Button>
            <Button type="primary" onClick={() => form.submit()}>{t("Lưu", "Lưu")}</Button>
          </Space>
        }
      >
        <Form
          className="active-settings-chapter"
          layout={"vertical"}
          form={form}
          name="confirm-participate-account"
          initialValues={{
            enterpriseCheckbox: false,
            accountCheckbox: false,
            createCourseCheckbox: false,
          }}  
        >
          <div className="m-5">
            <Row gutter={24}>
              <Col span={12}>
                <div className='border rounded-lg p-3 '>
                  <Typography.Title level={5}>{t("Chi tiết thông tin của cơ sở yêu cầu", "Chi tiết thông tin của cơ sở yêu cầu")}</Typography.Title>
                  <Collapse defaultActiveKey={["1", "2", "3"]}>
                    <Panel
                      header={t("Thông tin cơ sở đào tạo", "Thông tin cơ sở đào tạo")}
                      key="1"
                      className="setting-chapter-title">
                      <div className='m-5'>
                        <span className='flex'><Typography.Title level={5} className='min-w-[160px]'>{t("Cơ quan quản lý", "Cơ quan quản lý")}</Typography.Title> <p className='mt-0.5 ml-2'>{detailData?.organizationName}</p></span>
                        <span className='flex mt-2'><Typography.Title level={5} className='min-w-[160px]'>{t("Tên viết tắt", "Tên viết tắt")}</Typography.Title> <p className='mt-0.5 ml-2'>{detailData?.acronym}</p></span>
                        <span className='flex mt-2'><Typography.Title level={5} className='min-w-[160px]'>{t("Tên cơ sở đào tạo", "Tên cơ sở đào tạo")}</Typography.Title> <p className='mt-0.5 ml-2'>{detailData?.name}</p></span>
                        <span className='flex mt-2'><Typography.Title level={5} className='min-w-[160px]'>{t("Loại trường", "Loại trường")}</Typography.Title> <p className='mt-0.5 ml-2'>{detailData?.trainingTypeName}</p></span>
                        <span className='flex mt-2'><Typography.Title level={5} className='min-w-[160px]'>{t("Loại hình", "Loại hình")}</Typography.Title> <p className='mt-0.5 ml-2'>{detailData?.universityTypeName}</p></span>
                      </div>
                    </Panel>

                    <Panel
                      header={t("Địa chỉ cơ sở đào tạo", "Địa chỉ cơ sở đào tạo")}
                      key="2"
                      className="setting-chapter-title">
                      <div className='m-5'>
                        <span className='flex'><Typography.Title level={5} className='min-w-[160px]'>{t("Thành phố/Tỉnh", "Thành phố/Tỉnh")}</Typography.Title> <p className='mt-0.5 ml-2'>{detailData?.provinceName}</p></span>
                        <span className='flex mt-2'><Typography.Title level={5} className='min-w-[160px]'>{t("Quận/Huyện", "Quận/Huyện")}</Typography.Title> <p className='mt-0.5 ml-2'>{detailData?.districtName}</p></span>
                        <span className='flex mt-2'><Typography.Title level={5} className='min-w-[160px]'>{t("Phường/Xã", "Phường/Xã")}</Typography.Title> <p className='mt-0.5 ml-2'>{detailData?.wardName}</p></span>
                        <span className='flex mt-2'><Typography.Title level={5} className='min-w-[160px]'>{t("Địa chỉ chi tiết", "Địa chỉ chi tiết")}</Typography.Title> <p className='mt-0.5 ml-2'>{detailData?.address}</p></span>
                      </div>
                    </Panel>

                    <Panel
                      header={t("Địa chỉ cơ sở đào tạo", "Địa chỉ cơ sở đào tạo")}
                      key="3"
                      className="setting-chapter-title">
                      <div className='m-5'>
                        <span className='flex'><Typography.Title level={5} className='min-w-[160px]'>{t("Chức vụ", "Chức vụ")}</Typography.Title> <p className='mt-0.5 ml-2'>{detailData?.userContactPositionName}</p></span>
                        <span className='flex mt-2'><Typography.Title level={5} className='min-w-[160px]'>{t("Số điện thoại", "Số điện thoại")}</Typography.Title> <p className='mt-0.5 ml-2'>{detailData?.userContactPhone}</p></span>
                        <span className='flex mt-2'><Typography.Title level={5} className='min-w-[160px]'>Email</Typography.Title> <p className='mt-0.5 ml-2'>{detailData?.userContactEmail}</p></span>
                      </div>
                    </Panel>
                  </Collapse>
                </div>
              </Col>
              <Col span={12}>
                <div className='p-3 '>
                  <Typography.Title level={5}>{t("Xử lý yêu cầu tham gia nền tảng", "Xử lý yêu cầu tham gia nền tảng")}</Typography.Title>
                  <hr className='mt-2 mb-2' />
                  <Form.Item name="enterpriseCheckbox" valuePropName="checked" rules={[validations.enterpriseCheckbox]} >
                    <Checkbox>
                      {t("Tạo thông tin Trường đại học", "Tạo thông tin Trường đại học")}
                    </Checkbox>
                  </Form.Item>
                  <Form.Item name="enterpriseId" rules={[validations.enterprise]} className='mt-2'>
                    <FormItemDropdown
                      placeholder={t("Chọn trường đại học", "Chọn trường đại học")}
                      options={listEnterPrise}
                      disabled={!listCheckbox.createSchoolInfo}
                    />
                  </Form.Item>
                  <hr className='mb-2' />

                  <Form.Item name="accountCheckbox" valuePropName="checked">
                    <Checkbox>
                      {t("Tạo tài khoản Quản trị cơ sở", "Tạo tài khoản Quản trị cơ sở")}
                    </Checkbox>
                  </Form.Item>
                  <Form.Item name="accountId" className='mt-2'>
                    <FormItemDropdown
                      placeholder={t("Chọn tài khoản", "Chọn tài khoản")}
                      options={listAccount}
                      disabled={!listCheckbox.createAccountInfo}
                    />
                  </Form.Item>
                  <hr className='mb-1' />
                  <Form.Item name="createCourseCheckbox" valuePropName="checked">
                    <Checkbox>
                      {t("Khởi tạo trang danh sách khóa học cho trường đại học", "Khởi tạo trang danh sách khóa học cho trường đại học")}
                    </Checkbox>
                  </Form.Item>
                  <Form.Item name="createCourse" className='mt-3'>
                    <TextArea
                      className="text-area-answer"
                      showCount
                      disabled={!listCheckbox.createCourseInfo}
                      placeholder={t("Nhập mô tả", "Nhập mô tả")}
                      maxLength={DEFAULT_MAX_LENGTH_COURSE_TEXTAREA}
                      autoSize={{ minRows: 5, maxRows: 10 }}
                    />
                  </Form.Item>
                </div>
              </Col>
            </Row>
          </div>
        </Form>
      </Drawer>
    </Form.Provider>
  )
}
